import React from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import { useAuth } from "../../context/AuthContext";
import { useToast } from "../../context/ToastContext";
import translations from "../../locals/translations.json";

const NotificationBar = ({ isLiveBidPage = false, auctionData = null }) => {
  const { language } = useLanguage();
  const { isAuthenticated, user } = useAuth();
  const { showWarning } = useToast();
  const navigate = useNavigate();

  const handleJoinNow = () => {
    // Check if user is not logged in or is a seller
    if (!isAuthenticated || user?.userType === "seller") {
      showWarning("Log in as buyer to join auction", {
        duration: 3000,
      });
      return;
    }

    // If user is a buyer, redirect to auction page
    if (user?.userType === "buyer") {
      navigate("/auctions");
    }
  };
  return (
    <div className='bg-gradient-to-r from-orange-500 via-black to-orange-500 h-[40px] sticky top-16 z-40 flex items-center justify-center overflow-hidden'>
      {/* Container with max width */}
      <div className='w-full  max-w-6xl mx-auto  flex items-center gap-3 justify-between overflow-hidden'>
        {/* Marquee content that will scroll */}
        <div className=' overflow-hidden'>
          <div className='animate-marquee  flex items-center space-x-2 md:space-x-8 lg:space-x-12 font-Poppins   md:text-[22px] text-white whitespace-nowrap'>
            {isLiveBidPage && auctionData ? (
              <>
                <div className=''>
                  🏷️ Live Auction: {auctionData.auctionName || "Live Auction"}
                </div>

                <div className='border-[1px] h-4 md:h-8 border-r border-[#FFFFFF]' />

                <div className=''>🔥 Lane:{auctionData?.laneName || "-"}</div>
              </>
            ) : (
              <>
                <div className=''>
                  🏷️ {translations[language].home.notification.exclusiveDeals}
                </div>

                <div className='border-[1px] h-4 md:h-8 border-r border-[#FFFFFF]' />

                <div className=''>
                  🔥 {translations[language].home.notification.joinNow}
                </div>
              </>
            )}
          </div>
        </div>

        <button
          onClick={handleJoinNow}
          className='bg-black text-white p-[10px]   md:text-[16px] font-normal flex-shrink-0 transition-colors duration-200 ml-4 skew-x-[-12deg] mx-4  border-[2px] border-[#FFFFFF] hover:bg-[#f06f15] '
        >
          Join Now
        </button>
      </div>
    </div>
  );
};

export default NotificationBar;
